import { render, staticRenderFns } from "./KeyCarousel.vue?vue&type=template&id=52cf0200&"
import script from "./KeyCarousel.vue?vue&type=script&lang=ts&"
export * from "./KeyCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports